var render, staticRenderFns
import script from "./Lazy.vue?vue&type=script&lang=js&"
export * from "./Lazy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/core-product/common/vue2/patsnap-biz/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1491c226')) {
      api.createRecord('1491c226', component.options)
    } else {
      api.reload('1491c226', component.options)
    }
    
  }
}
component.options.__file = "src/Lazy.vue"
export default component.exports